import { Settings2, DollarSign, CalendarClock } from 'lucide-react';
import { useSubmissionStore } from '@/stores/submissionStore';
import { useTranslation } from '@/lib/i18n';
import { SectionCard } from './SectionCard';
import { FieldLabel } from '../ui/FieldLabel';
import { ChoiceButton } from '../ui/ChoiceButton';
import { ToggleRow } from '../ui/ToggleRow';

export function Section03Options() {
  const submission = useSubmissionStore((s) => s.submission);
  const patchOptions = useSubmissionStore((s) => s.patchOptions);
  const { t } = useTranslation();

  const { options } = submission;

  return (
    <SectionCard
      num="03"
      title={t('section.03.title')}
      icon={<Settings2 size={18} strokeWidth={2} />}
    >
      <FieldLabel>{t('options.mode.label')}</FieldLabel>
      <div className="grid grid-cols-2 gap-2 mb-3">
        <ChoiceButton
          selected={!options.rental.enabled}
          onClick={() => patchOptions({ rental: { enabled: false, durationMonths: 0 } })}
          icon={<DollarSign size={14} strokeWidth={2} />}
        >
          {t('options.mode.achat')}
        </ChoiceButton>
        <ChoiceButton
          selected={options.rental.enabled}
          onClick={() => patchOptions({ rental: { enabled: true, durationMonths: 12 } })}
          icon={<CalendarClock size={14} strokeWidth={2} />}
        >
          {t('options.mode.location')}
        </ChoiceButton>
      </div>

      {options.rental.enabled && (
        <>
          <FieldLabel htmlFor="duration">{t('options.rental.duration')}</FieldLabel>
          <input
            id="duration"
            type="number"
            inputMode="numeric"
            min={1}
            max={36}
            value={options.rental.durationMonths}
            onChange={(e) =>
              patchOptions({
                rental: { ...options.rental, durationMonths: Number(e.target.value) || 0 },
              })
            }
            className="w-full mb-3 px-3 py-2.5 rounded-xl border border-[var(--line-strong,rgba(15,30,51,0.16))] bg-white focus-visible:outline-2 focus-visible:outline-[var(--brand-primary,#22D3EE)]"
          />
        </>
      )}

      <ToggleRow
        id="install-toggle"
        checked={options.installation.enabled}
        onChange={(c) => patchOptions({ installation: { ...options.installation, enabled: c } })}
        label={t('options.install.label')}
      />

      {options.installation.enabled && (
        <>
          <FieldLabel htmlFor="km">{t('options.install.km')}</FieldLabel>
          <input
            id="km"
            type="number"
            inputMode="numeric"
            min={0}
            value={options.installation.transportKm}
            onChange={(e) =>
              patchOptions({
                installation: { ...options.installation, transportKm: Number(e.target.value) || 0 },
              })
            }
            className="w-full mb-2 px-3 py-2.5 rounded-xl border border-[var(--line-strong,rgba(15,30,51,0.16))] bg-white focus-visible:outline-2 focus-visible:outline-[var(--brand-primary,#22D3EE)]"
          />
        </>
      )}

      <ToggleRow
        id="uninstall-toggle"
        checked={options.uninstallation.enabled}
        onChange={(c) => patchOptions({ uninstallation: { enabled: c } })}
        label={t('options.uninstall.label')}
      />
    </SectionCard>
  );
}
